import gql from 'graphql-tag';
import { mention } from '@shared/api/fragments/mention';

export const listMentions = gql`
  query ListMentionsQuery($input: ListMentionsInput!) {
    listMentions(input: $input) {
      mentions {
        ...Mention
      }
      hasMore
    }
  }

  ${mention}
`;
